import React from 'react';
export function Disclaimers() {
  return <section className="py-12 bg-gray-50 border-t border-legal-border" data-id="element-51">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-53">
          <div className="bg-white p-5 rounded border border-gray-200 text-sm text-gray-500 shadow-sm" data-id="element-54">
            *There are many exceptions, special definitions, and complex issues
            that cannot be explained in this material. It is not intended to be
            a substitute for specific legal advice. Your legal rights greatly
            depend on the facts of your accident.
          </div>
          <div className="bg-white p-5 rounded border border-gray-200 text-sm text-gray-500 shadow-sm" data-id="element-55">
            *Law changes constantly. Do not rely on this information. Law is
            vast and can not be covered in this limited space.
          </div>
          <div className="bg-white p-5 rounded border border-gray-200 text-sm text-gray-500 shadow-sm" data-id="element-56">
            ***Law portion of site in progress. Trucking law regarding semi
            truck accidents is being drafted and will be updated soon. Please
            call our firm for a free consultation to see if you have a case.
          </div>
        </div>
      </div>
    </section>;
}